module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 23.833v-6h4v6h5v-8h3l-10-9-10 9h3v8z\"></path></svg>"